// component
import BidCirculationList from './bid-circulation-list/bid-circulation-list.vue';
export default [
  {
    path: 'list',
    name: 'bidCirculationList',
    component: BidCirculationList,
    meta: {
      title: '报名流传标的',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];

